import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.css";
import { Table, Modal, Button, notification, Input } from "antd";
import { Link } from "react-router-dom";
import { baseApiUrl } from "../../services/api";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';


const Categories = () => {
  const [nom, setNom] = useState("");
  const [image, setImage] = useState("");
  const [categories, setCategories] = useState([]);
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [isViewModalVisible, setIsViewModalVisible] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);
  const [viewingCategory, setViewingCategory] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [deleteCategorie, setDeleteCategorie] = useState(null);

  const openNotificationWithIcon = (type, message) => {
    notification[type]({
      message: message,
    });
  };



  const fetchCategories = async () => {
    try {
      const response = await baseApiUrl.get(
        "/categorie/liste"
      );
      console.log("Données reçues des domaine:", response.data);

      // Vérifie que les données sont bien un tableau avant de les stocker
      setCategories(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error("Erreur lors de la récupération des domaine:", error);
    }
  };

  const handleAddCategory = async (e) => {
    e.preventDefault();

    if (!nom) {
      openNotificationWithIcon("error", "Veuillez remplir tous les champs.");
      return;
    }

    try {
      const formData = new FormData();
      const categorieData = { nom };
      console.log("Données catégorie:", categorieData);

      formData.append("categorie", new Blob([JSON.stringify(categorieData)], { type: "application/json" }));

      if (image) {
        console.log("Photo ajoutée:", image);
        formData.append("image", image);
      }

      const response = await baseApiUrl.post("/categorie/create", formData);

      // Vérifier le statut de la réponse
      if (response.status !== 200) {
        const errorText = await response.text();
        console.error("Erreur API:", errorText);
        throw new Error(`Erreur HTTP: ${response.status}`);
      }

      // Notification de succès
      openNotificationWithIcon("success", "Domaine ajoutée avec succès.");
      fetchCategories();
    } catch (error) {
      openNotificationWithIcon("error", "Erreur lors de l'ajout de la catégorie.");
      console.error("Erreur détectée:", error.message || error);
    }

    resetForm();
  };




  const handleEditCategory = async (e) => {
    e.preventDefault();

    if (!nom) {
      openNotificationWithIcon("error", "Veuillez remplir le nom de la catégorie.");
      return;
    }

    const formData = new FormData();
    const categorieData = { nom };
    formData.append("categorie", new Blob([JSON.stringify(categorieData)], { type: "application/json" }));

    if (image) {
      formData.append("image", image);
    }

    try {
      const response = await baseApiUrl.put(`/categorie/modifier/${editingCategory.id}`, formData);

      console.log("Response Status:", response.status);
      console.log("Response Body:", response.data);

      if (response.status !== 200) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }

      const updatedCategory = response.data;

      setCategories(
        categories.map((cat) => (cat.id === updatedCategory.id ? updatedCategory : cat))
      );

      openNotificationWithIcon("success", "Domaine modifiée avec succès.");
      resetForm();
    } catch (error) {
      console.error("Erreur:", error);
      openNotificationWithIcon("error", "Erreur lors de la modification de la catégorie.");
    }
  };

  const handleDelete = async (idCategorie) => {
    try {
      const response = await baseApiUrl.delete(`/categorie/delete/${idCategorie}`);

      if (response.status !== 200) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }

      setCategories(categories.filter((cat) => cat.id !== idCategorie));
      setDeleteModalVisible(false);
      setDeleteCategorie(null);
      openNotificationWithIcon("success", "Domaine supprimée avec succès.");
    } catch (error) {
      openNotificationWithIcon(
        "error",
        "Erreur lors de la suppression de la domaine."
      );
      console.error("Erreur:", error);
    }
  };


  const resetForm = () => {
    setNom("");
    setImage("");
    setIsEditMode(false);
    setEditingCategory(null);
    setIsAddModalVisible(false);
    setIsEditModalVisible(false);
    setIsViewModalVisible(false);
  };

  const handleEdit = (category) => {
    setIsEditMode(true);
    setEditingCategory(category);
    setNom(category.nom);
    setImage(category.image);
    setIsEditModalVisible(true);
  };

  const handleDeleteConfirm = (categorie) => {
    setDeleteCategorie(categorie);
    setDeleteModalVisible(true);
  };

  const handleView = (category) => {
    setViewingCategory(category);
    setIsViewModalVisible(true);
  };

  const filteredCategories = categories.filter((category) =>
    category.nom?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    fetchCategories();
  }, []);

  // -------------------------------------------

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-7 col-auto">
                {/* <h3 className="page-title">Domaines</h3> */}
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/admin">Accueil</Link>
                  </li>
                  <li className="breadcrumb-item active">Domaines</li>
                </ul><br />
                <div className="top-nav-search">
                  <input
                    className="form-control"
                    placeholder="Rechercher par nom"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-sm-5 col">
                <Button
                  type="success"
                  onClick={() => setIsAddModalVisible(true)}
                  className="float-end mt-2 btn-success"
                >
                  <FontAwesomeIcon icon={faPlus} className="me-2" /> {/* Icône ajoutée ici */}
                  Ajouter
                </Button>
              </div>
            </div>
          </div>

          <Table
            rowKey="id"
            columns={[
              { title: "Nom", dataIndex: "nom", key: "nom" },
              {
                title: "Image",
                dataIndex: "image",
                key: "image",
                render: (imageName) => {
                  // Définir le chemin complet de l'image
                  const imageUrl =
                    baseApiUrl.defaults.baseURL + `/image/${imageName}`;
                  return (
                    <img
                      src={imageUrl}
                      alt="logo"
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    />
                  );
                },
              },

              {
                title: "Actions",
                key: "actions",
                dataIndex: "actions",
                render: (text, record) => (
                  <div className="text-end">
                    <Button
                      className="ms-2 btn btn-sm bg-success-light"
                      onClick={() => handleView(record)}
                    >
                      Voir
                    </Button>
                    <Button
                      className="ms-2 btn btn-sm bg-primary-light"
                      onClick={() => handleEdit(record)}
                    >
                      Modifier
                    </Button>

                    <Button
                      className="ms-2 btn btn-sm bg-danger-light"
                      onClick={() => handleDeleteConfirm(record)}
                    >
                      Supprimer
                    </Button>

                  </div>
                ),
              },
            ]}
            dataSource={filteredCategories}
          />

          {/* Modal d'ajout de catégorie */}
          <Modal
            title="Ajouter un domaine"
            visible={isAddModalVisible}
            onCancel={() => setIsAddModalVisible(false)}
            footer={[
              <Button key="back" onClick={() => setIsAddModalVisible(false)}>
                Annuler
              </Button>,
              <Button key="submit" type="primary" onClick={handleAddCategory}>
                Ajouter
              </Button>,
            ]}
          >
            <form onSubmit={handleAddCategory}>
              <div className="form-group">
                <label>Nom</label>
                <input
                  type="text"
                  className="form-control"
                  value={nom}
                  onChange={(e) => setNom(e.target.value)}
                />
                <label>Image</label>
                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => setImage(e.target.files[0])}
                />
              </div>
            </form>
          </Modal>

          {/* Modal de modification de catégorie */}
          <Modal
            title="Modifier le domaine"
            visible={isEditModalVisible}
            onCancel={() => setIsEditModalVisible(false)}
            footer={[
              <Button key="back" onClick={() => setIsEditModalVisible(false)}>
                Annuler
              </Button>,
              <Button key="submit" type="primary" onClick={handleEditCategory}>
                Enregistrer les modifications
              </Button>,
            ]}
          >
            <form onSubmit={handleEditCategory}>
              <div className="form-group">
                <label>Nom</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Domaine"
                  value={nom}
                  onChange={(e) => setNom(e.target.value)}
                />
                <label>Image</label>
                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => setImage(e.target.files[0])}
                />
              </div>
            </form>
          </Modal>

          {/* Modal pour afficher les détails de la catégorie */}
          <Modal
            title="Détails du domaine"
            visible={isViewModalVisible}
            onCancel={() => setIsViewModalVisible(false)}
            footer={[
              <Button key="close" onClick={() => setIsViewModalVisible(false)}>
                Fermer
              </Button>,
            ]}
          >
            {viewingCategory && (
              <div>
                <p>
                  <strong>Nom :</strong> {viewingCategory.nom}
                </p>
                {/* Ajoutez d'autres champs ici si nécessaire */}
              </div>
            )}
          </Modal>

          <Modal
            title="Confirmer la suppression"
            visible={deleteModalVisible}
            onCancel={() => setDeleteModalVisible(false)}
            footer={[
              <Button key="back" onClick={() => setDeleteModalVisible(false)}>
                Annuler
              </Button>,
              <Button
                key="submit"
                type="primary"
                onClick={() => handleDelete(deleteCategorie.id)}
              >
                Supprimer
              </Button>,
            ]}
          >
            <p>Êtes-vous sûr de vouloir supprimer cet Domaine ?</p>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default Categories;
